<section class="contact-info-dialog">
  <!-- dialog header -->
  <div class="contact-info-dialog__header">
    <h4 class="contact-info-dialog__title">{{ title | translate }}</h4>
    <button (click)="close()">
      <i class="iconsax contact-info-dialog__icon" icon-name="x"></i>
    </button>
  </div>

  <!-- product images & videos -->
  <div class="contact-info-dialog__content">
    <ul class="info-list">
      @for (info of contactData; track $index) {
        @if (info.description) {
          <li class="info-list__item">
            <div class="info-name">
              <i
                class="info-name__icon iconsax"
                [attr.icon-name]="info.icon"></i>
              <span class="info-name__text">{{ info.title | translate }}</span>
            </div>
            <p
              class="info-description {{ info?.descriptionClasses }}"
              [ngClass]="{
                'info-description--is-ltr': info?.isNumberMode,
              }">
              {{ (info.description | translateData) || '' | translate }}
            </p>
          </li>
        }
      }
    </ul>
  </div>
</section>
